__turbopack_context__.v({
  "root": "AccessCell-module__4hnkrG__root",
});
